import {
  type BankAccountListItem,
  BankAccountStatus,
} from "Infrastructure/Api/Api";

// Account statuses that render the detail UI (balance, account info, set-as-primary)
// in a disabled / grayed-out state. Edit this list to change which states disable the UI.
export const DISABLED_DETAIL_STATUSES: ReadonlyArray<BankAccountStatus> = [
  BankAccountStatus.AwaitingVerification,
  BankAccountStatus.Restricted,
  BankAccountStatus.Inactive,
  BankAccountStatus.Rejected,
];

export const isBankAccountDetailDisabled = ({
  status,
  isTokenInvalid,
}: BankAccountListItem) =>
  DISABLED_DETAIL_STATUSES.includes(status) || isTokenInvalid;

// Account statuses where the account is non-actionable — every action row
// (authorize access, authorize payments, set as primary) is disabled.
export const DISABLED_ACTIONS_STATUSES: ReadonlyArray<BankAccountStatus> = [
  BankAccountStatus.Inactive,
  BankAccountStatus.Rejected,
];

export const areBankAccountActionsDisabled = ({
  status,
}: BankAccountListItem) => DISABLED_ACTIONS_STATUSES.includes(status);
